// Module
var code = "<div class=\"block height-100\"> <h2>Manage Data Sync</h2> <div id=\"dataGrid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;